
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.683 20.7c0-2.467.511-4.89 1.533-7.265 1.022-2.377 2.197-4.296 3.526-5.758a29.13 29.13 0 014.293-4.113c1.635-1.28 2.862-2.147 3.68-2.604.817-.457 1.38-.777 1.686-.96l4.14 3.838c-.614.457-1.38 1.143-2.3 2.057-1.125 1.188-2.25 2.696-3.373 4.524-1.431 2.102-2.044 3.975-1.84 5.62 2.248.275 4.14 1.188 5.672 2.742 1.533 1.554 2.3 3.382 2.3 5.484 0 2.284-.92 4.204-2.76 5.757-1.737 1.554-3.883 2.33-6.439 2.33-2.964 0-5.417-1.05-7.359-3.152-1.84-2.194-2.76-5.027-2.76-8.5zM0 20.7c0-2.467.511-4.89 1.533-7.265 1.022-2.377 2.198-4.296 3.526-5.758a29.13 29.13 0 014.293-4.113c1.635-1.28 2.862-2.147 3.68-2.604.817-.457 1.38-.777 1.686-.96l4.14 3.838c-.614.457-1.38 1.143-2.3 2.057-1.125 1.188-2.25 2.696-3.373 4.524-1.431 2.102-2.045 3.975-1.84 5.62 2.248.275 4.14 1.188 5.672 2.742 1.534 1.554 2.3 3.382 2.3 5.484 0 2.284-.92 4.204-2.76 5.757-1.737 1.554-3.883 2.33-6.438 2.33-2.965 0-5.417-1.05-7.36-3.152C.92 27.006 0 24.173 0 20.7z","fill":"#56BFC7"}})])
          )
        }
      }
    